import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const InfoFilledIcon = ({
  title = 'Info',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 24 24" {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" clipRule="evenodd" d="M23.3332 11.9998C23.3332 18.2591 18.2591 23.3332 11.9998 23.3332C5.74061 23.3332 0.666504 18.2591 0.666504 11.9998C0.666504 5.74061 5.74061 0.666504 11.9998 0.666504C18.2591 0.666504 23.3332 5.74061 23.3332 11.9998ZM12.0558 9.7785C12.6438 9.7785 13.1118 9.3105 13.1118 8.7225C13.1118 8.1345 12.6438 7.6665 12.0558 7.6665C11.4678 7.6665 10.9998 8.1345 10.9998 8.7225C10.9998 9.3105 11.4678 9.7785 12.0558 9.7785ZM12.9798 16.3065V10.5105H11.1318V16.3065H12.9798Z" />
  </CreateIconComponent>
);

export default InfoFilledIcon;
